<template>
  <div class="home-page">
    <GoBack :name="`任务详情`" :type="2" :path="`/mobile/task`"></GoBack>
    <div class="m-page1">
      <div class="lene-box">
        <div class="text-box">{{ info.number }}</div>
        <div class="text-title">
          <span>({{ info.platform }})</span>
        </div>
      </div>
      <div class="lene-title">{{ info.title }}</div>
      <div class="lene-box2">
        <div class="text-box">{{ $t("module.taskD.title4") }}</div>
        <div class="text-title">
          {{ info.minPoints }}~{{ info.maxPoints
          }}<span>{{ $t("module.taskD.title5") }}</span>
        </div>
      </div>
      <div class="lene-box3">
        <div class="text-box">{{ $t("module.taskD.title6") }}</div>
        <div class="text-title">
          {{ info.realtime === 1 ? "即时奖励" : "统一奖励" }}
        </div>
      </div>
      <div class="lene-box3">
        <div class="text-box">{{ $t("module.taskD.title8") }}</div>
        <div class="text-title">
          {{ $t("module.taskD.title9") }}<span>{{ info.loi }}</span
          >{{ $t("module.taskD.title10") }}
        </div>
      </div>
      <div class="lene-box3">
        <div class="text-box">{{ $t("module.taskD.title16") }}</div>
        <div class="text-title">
          <span>{{ info.ir }}%</span>
        </div>
      </div>

      <div class="tips-box">
        <div class="title">{{ $t("module.taskD.title14") }}</div>
        <div :class="['p-box', { 'p-box-en': $i18n.locale === 'en' }]">
          <p v-html="info.welcomeContent"></p>
        </div>
      </div>
      <div class="btn-box">
        <div :class="`btn ${flag ? 'btn-active' : ''}`" @click="submit(info)">
          {{ $t("module.taskD.title13") }}
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getSurveysItem, getsurveyTake } from "@/api/mobile";
import GoBack from "@/components/goBack.vue";
import Fingerprint from "@/utils/fingerprint";
export default {
  data() {
    return {
      id: 0,
      info: {
        id: 0,
        encryptId: null,
        number: null,
        title: null,
        minPoints: 0,
        maxPoints: 0,
        extraPoints: 0,
        realtime: 0,
        sticky: true,
        startDate: null,
        endDate: null,
        loi: 0,
        ir: 0,
        platformType: 0,
        platform: null,
        thumbImage: null,
        surveyLink: null,
        welcomeContent: null,
        endContent: null,
        dateline: null,
        commercial: true,
        allowedHide: true,
        shareable: true,
        package: null,
        webId: null,
      },
      flag: false,
      userInfo: {},
    };
  },
  methods: {
    submit(data) {
      if (this.flag) {
        return;
      }
      this.flag = true;
      getsurveyTake({
        encryptId: data.encryptId,
        webId: "aidajuan",
        anonymousId: "",
        uid: this.userInfo.id,
        gender: 0,
        birthday: "2026-05-20T01:16:12.237Z",
        provinceId: 0,
        cityId: 0,
        districtId: 0,
        fingerprintCode: new Fingerprint().get(),
        phoneCode: "",
        personalIncome: "",
        familyIncome: "",
        marriageId: 0,
        educationId: 0,
        extHintQuestion1Answer: "",
      }).then((res) => {
        this.flag = false;
        if (res.code === 200) {
          window.open(res.data, "_blank");
        }
      });
    },
  },
  async created() {
    if (this.$route.query.id) {
      this.id = this.$route.query.id;
    }
    if (localStorage.getItem("userInfo")) {
      this.userInfo = JSON.parse(localStorage.getItem("userInfo"));
      this.$store.commit("changeUserInfo", this.userInfo);
    } else {
      await getAccount().then((res) => {
        if (res.code === 200) {
          this.userInfo = res.data;
          this.$store.commit("changeUserInfo", this.userInfo);
          localStorage.setItem("userInfo", JSON.stringify(res.data));
        }
      });
    }
    getSurveysItem({ id: this.id }).then((res) => {
      if (res.code === 200) {
        this.info = {
          id: res.data.id,
          encryptId: res.data.encryptId,
          number: res.data.number,
          title: res.data.title,
          minPoints: res.data.minPoints,
          maxPoints: res.data.maxPoints,
          extraPoints: res.data.extraPoints,
          realtime: res.data.realtime,
          sticky: res.data.sticky,
          startDate: res.data.startDate,
          endDate: res.data.endDate,
          loi: res.data.LOI,
          ir: res.data.IR,
          platformType: res.data.platformType,
          platform: res.data.platform,
          thumbImage: res.data.thumbImage,
          surveyLink: res.data.surveyLink,
          welcomeContent: res.data.welcomeContent,
          endContent: res.data.endContent,
          dateline: res.data.dateline,
          commercial: res.data.commercial,
          allowedHide: res.data.allowedHide,
          shareable: res.data.shareable,
          package: res.data.package,
          webId: res.data.webId,
        };
      }
    });
  },

  components: { GoBack },
};
</script>
<style lang="scss" scoped>
.home-page {
  width: 100%;
  padding: 0 10px;
  color: #fefeff;
  box-sizing: border-box;
  .page1 {
    width: 100%;
    height: 62px;
    background: #ffffff;
    border-radius: 8px 8px 8px 8px;
    margin-top: 16px;
    box-sizing: border-box;
    padding-left: 30px;
    display: flex;
    align-items: center;
    color: #474f66;
    font-size: 16px;
    img {
      margin: 0 9px;
      width: 22px;
      height: 22px;
    }
  }

  .m-page1 {
    width: 100%;
    padding: 0 10px;
    box-sizing: border-box;
    background-color: #fff;
    margin-top: 10px;
    margin-bottom: 20px;
    color: #333333;
    .m-title {
      width: 100%;
      height: 48px;
      box-sizing: border-box;
      border-bottom: 1px solid #eeeeee;
      display: flex;
      align-items: center;
      color: #333333;
      img {
        width: 22px;
        height: 22px;
        transform: rotate(180deg);
        flex-shrink: 0;
      }
      span {
        width: 100%;
        text-align: center;
        font-size: 16px;
        font-weight: bolder;
      }
    }
    .lene-box {
      display: flex;
      justify-content: space-between;
      margin-top: 16px;
      margin-bottom: 7px;
      .text-box {
        font-size: 14px;
        font-weight: bolder;
      }
      .text-title {
        font-size: 14px;
        color: #999999;
        font-weight: bolder;
      }
    }
    .lene-title {
      font-size: 14px;
      font-weight: bolder;
    }
    .lene-box2 {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-top: 27px;
      margin-bottom: 15px;
      .text-box {
        font-size: 14px;
        font-weight: bolder;
      }
      .text-title {
        font-size: 18px;
        color: #8948ff;
        font-weight: bolder;
        span {
          font-weight: normal;
          font-size: 16px;
          margin-left: 5px;
        }
      }
    }
    .lene-box3 {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 15px;
      .text-box {
        font-size: 14px;
        font-weight: bolder;
      }
      .text-title {
        font-size: 14px;
        span {
          font-size: 18px;
          font-weight: bolder;
          color: #8948ff;
        }
      }
    }
    .tips-box {
      margin-top: 30px;
      background-color: #f9f5ff;
      padding: 14px;
      box-sizing: border-box;
      line-height: 24px;
      .title {
        font-weight: bolder;
        margin-bottom: 14px;
      }
    }
    .btn-box {
      display: flex;
      justify-content: flex-end;
      padding: 48px 0 30px 0;
      align-items: center;
      .btn {
        width: 104px;
        height: 32px;
        line-height: 32px;
        text-align: center;
        color: #fff;
        font-size: 14px;
        cursor: pointer;
        background: linear-gradient(141deg, #a896ff 0%, #8b4eff 100%);
        box-shadow: 0px 3px 15px 1px rgba(137, 72, 255, 0.4);
        border-radius: 16px 16px 16px 16px;
      }
      .btn-active {
        opacity: 0.7;
      }
      .title {
        color: #232323;
        font-size: 14px;
        margin-right: 24px;
      }
    }
  }
}
</style>

